import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=85763e4a&scoped=true&"
import script from "./Alerts.vue?vue&type=script&lang=js&"
export * from "./Alerts.vue?vue&type=script&lang=js&"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=85763e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85763e4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
